<template>
  <v-container fluid tag="section" class="text_google login-page">
    <!-- ป้ายประกาศเปิดปรับข้อมูลส่วนตัว ด้านวุฒิลูกเสือ — ให้เห็นเด่นชัดเป็นอันดับแรกของหน้าแรกระบบ -->
    <v-row v-if="scoutPeriod.open" justify="center" class="mb-3">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="success"
          elevation="4"
          class="scout-banner"
          icon="mdi-tent"
          prominent
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <div class="scout-banner-title">
                <v-icon color="success" class="mr-1">mdi-bullhorn-outline</v-icon>
                เปิดให้ปรับข้อมูลส่วนตัว ด้านวุฒิลูกเสือแล้ว
              </div>
              <div class="scout-banner-desc">
                สำหรับบุคลากรที่มีข้อมูลลูกเสือวิสามัญอาชีวศึกษา สามารถเข้าสู่ระบบแล้วดำเนินการปรับปรุงข้อมูลได้ตั้งแต่วันนี้<span v-if="scoutPeriod.stop">
                  ถึงวันที่ <strong>{{ scoutPeriod.stop | moment("add", "543 years") | moment("D MMMM YYYY") }}</strong></span>
              </div>
            </div>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <!-- แถบแสดงสถานะการตรวจสอบความพร้อมของ web browser และระบบปฏิบัติการ — แสดงเสมอ (ไม่บล็อกการใช้งาน) -->
    <v-row justify="center" class="mb-2">
      <v-col cols="12" md="10">
        <div class="readiness-bar">
          <v-icon small color="grey darken-1" class="mr-1">mdi-monitor-dashboard</v-icon>
          <span class="readiness-label">ตรวจสอบความพร้อมของระบบ:</span>
          <v-chip small :color="browserOk ? 'green' : 'orange'" dark class="mx-1 readiness-chip">
            <v-icon left x-small>{{ browserOk ? "mdi-check-circle" : "mdi-alert" }}</v-icon>
            เบราว์เซอร์: {{ browserName }}{{ browserVersion ? " " + browserVersion : "" }}
          </v-chip>
          <v-chip small color="blue-grey" dark class="mx-1 readiness-chip">
            <v-icon left x-small>mdi-desktop-classic</v-icon>
            ระบบปฏิบัติการ: {{ osName }}
          </v-chip>
        </div>
        <v-alert
          v-if="browserWarningShow"
          type="warning"
          outlined
          dense
          dismissible
          border="left"
          class="browser-warning mt-2"
          @input="browserWarningShow = $event"
        >
          {{ browserWarningText }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" sm="6"><Loginuser /></v-col>
          <v-col cols="12" sm="6"><LoginCollege /></v-col>
          <v-col cols="12" sm="6"><Loginuser_gov /></v-col>
          <v-col cols="12" sm="6"><LoginuserEtc /></v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="4">
        <v-card rounded="lg" elevation="2" class="group-guide-card">
          <v-card-title class="guide-title">
            <v-icon left color="primary">mdi-information-outline</v-icon>
            คำอธิบายการเข้าใช้งานแต่ละกลุ่มผู้ใช้
          </v-card-title>
          <v-card-text>
            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#1976d2"></span>
                <span class="guide-name">ข้าราชการครูและบุคลากรทางการศึกษา</span>
              </div>
              <p class="guide-desc">
                สำหรับครู ผู้อำนวยการ รองผู้อำนวยการ และพนักงานราชการ ใช้ <strong>เลขบัตรประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
              <div class="guide-thaid-row">
              
                <v-chip  color="primary" outlined class="guide-thaid-chip">
                    <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID ทุกบัญชี
                </v-chip>
                <a href="#" class="thaid-link" @click.prevent="showThaidInfo = true">ดูขั้นตอน</a>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#e53e3e"></span>
                <span class="guide-name">ผู้ดูแลระบบ / สถานศึกษา / สถาบัน / สอจ.</span>
              </div>
              <p class="guide-desc">
                สำหรับหน่วยงาน (วิทยาลัย สถาบันการอาชีวศึกษา สำนักงานอาชีวศึกษาจังหวัด) และผู้ดูแลระบบส่วนกลาง ใช้ <strong>รหัสหน่วยงาน</strong> เป็นชื่อผู้ใช้งาน
              </p>
              <div class="guide-thaid-row">               
                <v-chip color="primary" outlined class="guide-thaid-chip">
                  <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID
                </v-chip>
                <a href="#" class="thaid-link" @click.prevent="showThaidInfo = true">ดูขั้นตอน</a>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#7b1fa2"></span>
                <span class="guide-name">พนักงานราชการ</span>
              </div>
              <p class="guide-desc">
                สำหรับพนักงานราชการในสังกัด ใช้ <strong>เลขบัตรประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
               <v-chip color="primary" outlined class="guide-thaid-chip">
                  <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID
                </v-chip>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#f57c00"></span>
                <span class="guide-name">บุคลากรทางการศึกษาอื่น</span>
              </div>
              <p class="guide-desc">
                สำหรับครูอัตราจ้าง ลูกจ้างประจำ และลูกจ้างชั่วคราว ใช้ <strong>เลขบัตรประชาชน / Passport / รหัสประจำตัวประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
            </div>

            <v-alert dense outlined color="grey darken-1" class="mt-4 mb-0 guide-note">
              <v-icon left small color="grey darken-1">mdi-help-circle-outline</v-icon>
              ไม่แน่ใจว่าเป็นกลุ่มใด กรุณาติดต่อผู้ดูแลระบบของหน่วยงานท่าน
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2 mb-8">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="manual-banner"
          icon="mdi-shield-check-outline"
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <strong>ระบบมีการอัปเดตความปลอดภัย</strong> — บางบัญชีอาจได้รับแจ้งให้ตั้งรหัสผ่านใหม่ทันทีหลังเข้าสู่ระบบ
              ถือเป็นขั้นตอนปกติเพื่อความปลอดภัยของท่าน
              <a href="#" class="info-link" @click.prevent="showPasswordInfo = true">
                อ่านรายละเอียดกระบวนการจัดการรหัสผ่าน
              </a>
            </div>
            <v-btn color="primary" to="/news" rounded outlined class="ml-auto mt-2 mt-sm-0">
              <v-icon left small>mdi-book-open-page-variant</v-icon>คู่มือการใช้งาน
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <!-- อธิบายกระบวนการจัดการรหัสผ่านแบบละเอียด — เปิดจากลิงก์ในป้ายประกาศด้านบน
         ตั้งใจไม่ระบุรูปแบบ/ตัวอย่างรหัสผ่านเริ่มต้นไว้ตรงนี้ เพื่อไม่เปิดเผยข้อมูลที่ผู้ไม่ประสงค์ดี
         อาจนำไปใช้เดารหัสผ่านได้ -->
    <v-dialog v-model="showPasswordInfo" max-width="600">
      <v-card rounded="xl" class="password-info-card">
        <v-card-title class="password-info-header white--text">
          <v-icon left color="white">mdi-lock-check-outline</v-icon>
          กระบวนการจัดการรหัสผ่าน
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">1</v-avatar>
            <div>
              <strong>เข้าใช้งานครั้งแรก หรือจำรหัสผ่านไม่ได้</strong>
              <p class="mb-0 grey--text text--darken-1">
                กรุณาติดต่อผู้ดูแลระบบของหน่วยงานท่าน หรือกดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบของแต่ละประเภทผู้ใช้งานด้านบน
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">2</v-avatar>
            <div>
              <strong>ระบบขอให้ตั้งรหัสผ่านใหม่ทันทีที่เข้าสู่ระบบ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เป็นส่วนหนึ่งของการยกระดับความปลอดภัยของระบบ ไม่ใช่ความผิดพลาดของท่าน กรุณาตั้งรหัสผ่านใหม่ตามที่ระบบแนะนำก่อนใช้งานต่อ
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">3</v-avatar>
            <div>
              <strong>ลืมรหัสผ่าน</strong>
              <p class="mb-0 grey--text text--darken-1">
                กดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบ ระบบจะส่งรหัสยืนยัน (OTP) ไปยังอีเมลที่ลงทะเบียนไว้ในระบบเท่านั้น
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">4</v-avatar>
            <div>
              <strong>การตั้งรหัสผ่านที่ปลอดภัย</strong>
              <p class="mb-0 grey--text text--darken-1">
                อย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลขอย่างน้อยอย่างละ 1 ตัว และไม่ควรใช้ซ้ำกับรหัสผ่านที่ใช้ในระบบอื่น
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded @click="showPasswordInfo = false">เข้าใจแล้ว</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ขั้นตอนการยืนยันตัวตนผ่าน ThaiID — เปิดจากลิงก์ "ดูขั้นตอน" ในการ์ดคำอธิบายกลุ่มผู้ใช้งานด้านบน -->
    <v-dialog v-model="showThaidInfo" max-width="600">
      <v-card rounded="xl" class="password-info-card">
        <v-card-title class="thaid-info-header white--text">
          <v-icon left color="white">mdi-qrcode-scan</v-icon>
          ขั้นตอนการยืนยันตัวตนผ่าน ThaiID 
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="thaid-intro">
            ThaiID คือแอปพลิเคชันยืนยันตัวตนทางดิจิทัล ออกให้โดย<strong>กรมการปกครอง กระทรวงมหาดไทย</strong>
            ใช้เป็นการยืนยันตัวตนขั้นที่สอง (นอกเหนือจากรหัสผ่าน) สำหรับบัญชีบางกลุ่มของระบบนี้
          </p>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">1</v-avatar>
            <div>
              <strong>กรอกชื่อผู้ใช้งานและรหัสผ่านตามปกติ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เข้าสู่ระบบตามขั้นตอนเดิมทุกอย่าง หากรหัสผ่านถูกต้อง ระบบจะพาไปขั้นตอนถัดไปโดยอัตโนมัติ
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">2</v-avatar>
            <div>
              <strong>ระบบพาไปหน้ายืนยันตัวตนของ ThaiID</strong>
              <p class="mb-0 grey--text text--darken-1">
                หน้าจอจะเปลี่ยนไปยังเว็บไซต์ของกรมการปกครองโดยอัตโนมัติ พร้อมแสดง QR Code สำหรับสแกน
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">3</v-avatar>
            <div>
              <strong>สแกน QR Code ด้วยแอป ThaID</strong>
              <p class="mb-0 grey--text text--darken-1">
                เปิดแอป ThaID บนโทรศัพท์มือถือ สแกน QR Code บนหน้าจอ แล้วยืนยันตัวตนด้วย PIN ของท่านในแอป
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">4</v-avatar>
            <div>
              <strong>เข้าสู่ระบบสำเร็จโดยอัตโนมัติ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เมื่อยืนยันตัวตนผ่าน ThaID สำเร็จ ระบบจะพาท่านกลับเข้าสู่ระบบ HRVEC ให้อัตโนมัติ ไม่ต้องกรอกข้อมูลซ้ำ
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded @click="showThaidInfo = false">เข้าใจแล้ว</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LoginCollege from "../components/core/loginCollege.vue";
import Loginuser from "../components/core/loginuser.vue";
import Loginuser_gov from "../components/core/loginuser_gov.vue";
import LoginuserEtc from "../components/core/loginuserEtc.vue";

export default {
  components: {
    Loginuser,
    LoginCollege,
    LoginuserEtc,
    Loginuser_gov
  },
  data() {
    return {
      showPasswordInfo: false,
      showThaidInfo: false,
      browserWarningShow: false,
      browserWarningText: "",
      browserName: "",
      browserVersion: "",
      browserOk: true,
      osName: "",
      scoutPeriod: { open: false, stop: "" }
    };
  },
  async mounted() {
    this.checkBrowserReadiness();
    await this.queryScoutPeriodStatus();
  },
  methods: {
    checkBrowserReadiness() {
      const ua = window.navigator.userAgent || "";

      // ── ตรวจสอบ OS (แสดงผลอย่างเดียว ไม่มีผลต่อ browserOk) ──
      if (/Windows/.test(ua)) this.osName = "Windows";
      else if (/Mac OS X/.test(ua)) this.osName = "macOS";
      else if (/Android/.test(ua)) this.osName = "Android";
      else if (/iPhone|iPad|iPod/.test(ua)) this.osName = "iOS";
      else if (/Linux/.test(ua)) this.osName = "Linux";
      else this.osName = "ไม่ทราบ";

      // ── ตรวจสอบเบราว์เซอร์ + เวอร์ชัน ──
      const isIE = !!window.document.documentMode || /Trident\/|MSIE /.test(ua);
      const isOldEdge = /Edge\/\d+/.test(ua); // Edge เดิม (EdgeHTML) ต่างจาก Edge ใหม่ที่ใช้ Chromium (UA มี "Edg/")
      const edgMatch = ua.match(/Edg\/(\d+)/); // Edge ใหม่ (Chromium)
      const operaMatch = ua.match(/OPR\/(\d+)/);
      const chromeMatch = !edgMatch && !operaMatch && ua.match(/Chrom(?:e|ium)\/(\d+)/);
      const firefoxMatch = ua.match(/Firefox\/(\d+)/);
      const isSafariUa = !/Chrom(?:e|ium)|Edg\/|OPR\//.test(ua);
      const safariMatch = isSafariUa && ua.match(/Version\/(\d+).*Safari/);

      if (isIE || isOldEdge) {
        this.browserName = isIE ? "Internet Explorer" : "Microsoft Edge (รุ่นเก่า)";
        this.browserVersion = "";
        this.browserOk = false;
        this.browserWarningShow = true;
        this.browserWarningText =
          "ตรวจพบว่าท่านใช้ Internet Explorer หรือ Microsoft Edge รุ่นเก่า ซึ่งอาจแสดงผลหรือใช้งานบางฟังก์ชันของระบบได้ไม่สมบูรณ์ แนะนำให้ใช้ Google Chrome, Microsoft Edge (รุ่นใหม่) หรือ Firefox เวอร์ชันล่าสุด";
        return;
      }

      if (edgMatch) {
        this.browserName = "Microsoft Edge";
        this.browserVersion = edgMatch[1];
      } else if (operaMatch) {
        this.browserName = "Opera";
        this.browserVersion = operaMatch[1];
      } else if (chromeMatch) {
        this.browserName = "Google Chrome";
        this.browserVersion = chromeMatch[1];
      } else if (firefoxMatch) {
        this.browserName = "Firefox";
        this.browserVersion = firefoxMatch[1];
      } else if (safariMatch) {
        this.browserName = "Safari";
        this.browserVersion = safariMatch[1];
      } else {
        this.browserName = "ไม่ทราบชนิดเบราว์เซอร์";
        this.browserVersion = "";
      }

      const isOutdated =
        (chromeMatch && Number(chromeMatch[1]) < 90) ||
        (firefoxMatch && Number(firefoxMatch[1]) < 88) ||
        (safariMatch && Number(safariMatch[1]) < 13);

      if (isOutdated) {
        this.browserOk = false;
        this.browserWarningShow = true;
        this.browserWarningText =
          "เบราว์เซอร์ของท่านเป็นเวอร์ชันเก่า แนะนำให้อัปเดตเป็นเวอร์ชันล่าสุดเพื่อการใช้งานที่ราบรื่นและปลอดภัยยิ่งขึ้น";
      } else {
        this.browserOk = true;
      }
    },
    async queryScoutPeriodStatus() {
      try {
        const result = await this.$http.post("period_status.php", {
          ApiKey: "HRvec2021",
          period_type: "scout"
        });
        this.scoutPeriod.open = !!result.data.period_open;
        this.scoutPeriod.stop = result.data.period_stop || "";
      } catch (e) {
        this.scoutPeriod.open = false;
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
</style>

<style scoped>
.text_google {
  font-family: "Kanit", sans-serif;
}

.login-page {
  min-height: 100vh;
}

.brand-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 4px;
}

.brand-subtitle {
  color: #718096;
  font-size: 1.05rem;
}

.manual-banner {
  border-radius: 12px;
}

.scout-banner {
  border-radius: 12px;
  animation: scout-banner-pop 0.4s ease-out;
  box-shadow: 0 4px 18px rgba(46, 125, 50, 0.25) !important;
}

.scout-banner-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1b5e20;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.scout-banner-desc {
  font-size: 0.98rem;
  line-height: 1.6;
  color: #33691e;
}

@keyframes scout-banner-pop {
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.readiness-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 0.85rem;
  color: #616161;
}

.readiness-label {
  margin-right: 4px;
  font-weight: 500;
}

.readiness-chip {
  font-size: 0.78rem !important;
}

.info-link {
  margin-left: 4px;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
}

.password-info-header {
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
}

.info-step p {
  font-size: 0.92rem;
  line-height: 1.5;
}

.group-guide-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.guide-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1.4;
}

.guide-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.guide-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.guide-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2d3748;
}

.guide-desc {
  font-size: 0.98rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 0;
  padding-left: 22px;
}

.guide-thaid-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 22px;
  margin-top: 8px;
}

.guide-thaid-chip {
  font-weight: 600;
  pointer-events: none;
}

.thaid-link {
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
}

.guide-note {
  font-size: 0.92rem;
}

.thaid-info-header {
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
}

.thaid-intro {
  font-size: 0.96rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 20px;
}

@media (min-width: 960px) {
  .group-guide-card {
    position: sticky;
    top: 24px;
  }
}

@media (max-width: 600px) {
  .brand-title {
    font-size: 1.5rem;
  }

  .guide-name {
    font-size: 1rem;
  }

  .guide-desc {
    font-size: 0.94rem;
  }
}
</style>
